export default __webpack_public_path__ + "static/media/evo-girl.0f97b15b.webp";